import type { JSX } from "react";
import { useMetadata } from "hooks/useMetadata";
import dynamic from "next/dynamic";
import { getPageTranslations } from "utils/server";
import { isLocaleInStaticRoute } from "@utils";
import { GetStaticProps } from "next";
import { YuLifeLocale } from "@hooks";
import { StaticRoutes } from "@routes";
import { Meta } from "components/atoms/Meta";
import { strapiService } from "@services";

const InsuranceCarriers = dynamic(() => import("../../components/pages/InsuranceCarriers/index"));

export default function InsuranceCarriersPage({
  keyResources,
  latestCaseStudy,
  locale,
}): JSX.Element {
  const metadata = useMetadata("insurance-carriers");

  return (
    <>
      <Meta locale={locale} {...metadata} />
      <InsuranceCarriers keyResources={keyResources || []} latestCaseStudy={latestCaseStudy} />
    </>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const locale = context.locale as YuLifeLocale;

  if (!isLocaleInStaticRoute(locale, StaticRoutes.ourSolutionsInsuranceCarriers)) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      ...(await strapiService.getGenericProps("uk", {
        hasKeyResources: true,
        hasLatestCaseStudy: true,
        resourceType: "newsAndEvents",
      })),
      messages: await getPageTranslations(locale),
    },
  };
};
